<template>
  <div>
    <div class="wrapper">
      <div class="trigger" @click="openDropDown()">
        <slot></slot>
      </div>
      <div v-if="droppedDown">
        <div class="background" @click="handleCloseDropdown()"></div>
        <div class="dropdown" @click.stop>
          <div class="content">
            <div>
              <router-link :to="dashboardLink">
                <div class="row" @click="onDashboardClick()">
                  <span>DASHBOARD</span>
                </div>
              </router-link>
              <router-link :to="myProfileLink">
                <div class="row" @click="onMyProfileClick()">
                  <span>MY PROFILE</span>
                </div>
              </router-link>
              <router-link :to="homeLink">
                <div class="row" @click="onLogoutClick">
                  <span>LOGOUT</span>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {loggerMixin} from '../../mixins/logger'
  import {
    R_NAME_HOME,
    R_NAME_DASHBOARD,
    LOGOUT, R_NAME_MY_PROFILE,
  } from '../../services/constants'

  export default {
    name: 'UserDropdown',
    mixins: [loggerMixin],
    data() {
      return {
        showState: false,
      }
    },
    computed: {
      ...mapGetters([]),
      droppedDown() {
        return this.showState
      },
      dashboardLink() {
        return {
          name: R_NAME_DASHBOARD
        }
      },
      myProfileLink() {
        return {
          name: R_NAME_MY_PROFILE
        }
      },
      homeLink() {
        return {
          name: R_NAME_HOME
        }
      },
    },
    methods: {
      openDropDown() {
        this.showState = true
      },
      handleCloseDropdown() {
        this.showState = false
      },
      onDashboardClick() {
        this.handleCloseDropdown()
      },
      onMyProfileClick() {
        this.handleCloseDropdown()
      },
      onLogoutClick() {
        this.$store.dispatch(LOGOUT)
        this.handleCloseDropdown()
      },
    },
    created() {
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";

  .wrapper {
    position: relative;
  }

  .trigger {
    cursor: pointer;
    display: flex;
  }

  .background {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .dropdown {
    display: inline-block;
    position: absolute;
    right: 0;
    width: 80vw;
    max-width: 380px;
    background-color: $yellow-green-1;
    color: white;
    font-size: 16px;
    font-weight: lighter;
    box-shadow: $cyan-blue-3 0 2px 4px 0;
  }

  .content {

    .row {
      padding: 1em;
      border-bottom: solid 1px $cyan-blue-3;
    }
    a {
      color: $cyan-blue-3;
      text-decoration: none;
    }
  }
</style>
